export const MERCHANT_ROOT = '/merchant'
export const MERCHANT_LOGIN = '/merchant/login'
export function isMerchantRole(role: unknown) { return role === 'merchant' }
export function isMerchantPath(path: string) { return path === MERCHANT_ROOT || path.startsWith(MERCHANT_ROOT + '/') }
export function isMerchantHost(host = window.location.host) {
  return String(process.env.VUE_APP_MERCHANT_HOSTS || '').split(',').map(value => value.trim().toLowerCase()).filter(Boolean).includes(host.toLowerCase())
}
export function safeMerchantRedirect(value: unknown) {
  if (typeof value !== 'string' || /[\\\u0000-\u0020]/.test(value) || !value.startsWith('/') || value.startsWith('//')) return ''
  try {
    const target = new URL(value, 'https://merchant.invalid')
    if (target.origin !== 'https://merchant.invalid') return ''
    if ((isMerchantPath(target.pathname) && target.pathname !== MERCHANT_LOGIN) || target.pathname === '/trend-authorize') return target.pathname + target.search + target.hash
  } catch (_) { /* Ignore malformed links. */ }
  return ''
}
export function merchantStatusLabel(status: string) {
  return ({ active: '服务已开通', not_opened: '尚未开通', expired: '服务已到期', paused: '服务已暂停', internal: '内部使用' } as Record<string, string>)[status] || '待确认'
}
export function merchantDate(value: string | null) {
  if (!value) return '尚未设置'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '尚未设置' : new Intl.DateTimeFormat('zh-CN', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).format(date)
}
